import React, { useState, useEffect, useRef } from "react";
import { Grid, AutoSizer } from "react-virtualized";

import { useSelector, useDispatch } from "types/store";

import Select from "react-select";

import { Button } from "aible";

import * as MarketReducer from "containers/CommunityMarket/MarketReducer";
import * as folderReducer from "containers/Folders/reducer";

import MarketItemCard from "components/CommunityMarket/MarketItemCard";

import styles from "./style.module.css";

const CartGrid = (props) => {
  const { cards } = props;

  const dispatch = useDispatch();

  const folders = useSelector((state) => folderReducer.getFoldersArr(state));
  const defaultFolderId = useSelector((state) => folderReducer.getDefaultFolderId(state));

  const updateCartItemsArray = (cartItems) => dispatch(MarketReducer.updateCartItemsArray(cartItems));
  const addAllItemsToFolder = (cartItems, folderId) => dispatch(MarketReducer.addAllItemsToFolder(cartItems, folderId));
  const isCartOpen = useSelector((state) => MarketReducer.getIsCartOpen(state));
  const updateIsCartOpen = (bool) => dispatch(MarketReducer.updateIsCartOpen(bool));

  const folderOptions =
    folders
      ?.filter((folder) => {
        return folder?.permissions?.can_edit === true;
      })
      .map((folder) => {
        return {
          value: folder.id,
          label: folder.name
        };
      }) ?? [];

  const defaultFolder = folderOptions?.find((folder) => folder?.value === defaultFolderId);
  const [selectedFolder, updateSelectedFolder] = useState(defaultFolder ?? folderOptions[0]);
  const [cartProcessing, updateCartProcessing] = useState(false);

  return (
    <React.Fragment>
      <div className={styles.marketCartGridContainer}>
        <AutoSizer>
          {({ height, width }) => {
            const minColumnWidth = 310;
            const columnCount = 1;
            const columnWidth = Math.floor((width - 50) / columnCount);
            const rowCount = Math.ceil(cards.length / columnCount);

            return (
              <Grid
                cellRenderer={(props) => <RenderCard {...props} columnCount={columnCount} cards={cards} />}
                columnCount={columnCount}
                columnWidth={columnWidth}
                height={height}
                rowCount={rowCount}
                rowHeight={330}
                width={width}
              />
            );
          }}
        </AutoSizer>
      </div>
      <div className={styles.folderSelectionContainer}>
        {cards?.length > 0 && (
          <div className={styles.folderSelection}>
            <div className={styles.folderSelectionLabel}>{"Which folder would you like to add to?"}</div>
            <div className={styles.folderSelectWrapper}>
              <Select
                value={selectedFolder}
                options={folderOptions}
                placeholder={"Select a folder to add your cart to"}
                onChange={(val) => updateSelectedFolder(val)}
                menuPlacement={"top"}
              />
            </div>
            <div>
              <Button
                onClick={() => {
                  updateCartProcessing(true);
                  addAllItemsToFolder(cards, selectedFolder?.value).then((response) => {
                    updateCartProcessing(false);
                    updateCartItemsArray([]);
                    updateIsCartOpen(false);
                  });
                }}
                type="primary"
                isLoading={cartProcessing}
              >
                {"Add to Folder"}
              </Button>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

const RenderCard = (props) => {
  const { columnIndex, rowIndex, style, cards, columnCount, ...retProps } = props;

  const dispatch = useDispatch();

  const removeFromCart = (itemId) => dispatch(MarketReducer.removeFromCart(itemId));
  const cartItemsArray = useSelector((state) => MarketReducer.getCartItemsArray(state));
  const updateIsCartOpen = (bool) => dispatch(MarketReducer.updateIsCartOpen(bool));

  const index = rowIndex * columnCount + columnIndex;
  const card = cards[index];

  return (
    <div className={styles.marketGridCell} key={columnIndex + "__" + rowIndex} style={style}>
      {card && (
        <React.Fragment>
          <div style={{ marginRight: "20px" }}>
            <MarketItemCard {...card} />
          </div>
          <div>
            <Button
              onClick={() => {
                removeFromCart(card?.id);
                if (cartItemsArray?.length === 1) {
                  updateIsCartOpen(false);
                }
              }}
            >
              {"Remove"}
            </Button>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default CartGrid;
